export class SecurityVulnerability {

  public id: number;
  public title: string;
  public type: string;
  public createDate: Date;
  public updateDate: Date;
  public publishedDate: Date;
  public references: string[];
  public fixedIn: string;

}
